<template>

<com-item name="games.summary" :size="size" :loading="loading" theme="blue" title="Games">

	<template v-slot:stats>

		<core-widget class="summary">

			<com-empty v-if="!active" :loading="loading" text="No games data" />

			<div class="summary-total" v-if="active" v-fit>{{ data.totalTouched }}</div>

			<div class="summary-change" v-if="active">

				<div class="summary-change-title"><span>Breakdown</span></div>

				<div class="summary-change-items">

					<div class="summary-change-item">
						<div class="summary-change-item-value" v-fit>{{ data.owned }}</div>
						<div class="summary-change-item-text">own</div>
					</div>

					<div class="summary-change-item" v-if="data.prevowned">
						<div class="summary-change-item-value" v-fit>{{ data.prevowned }}</div>
						<div class="summary-change-item-text">prev. owned</div>
					</div>

					<div class="summary-change-item">
						<div class="summary-change-item-value" v-fit>{{ data.played }}</div>
						<div class="summary-change-item-text">played</div>
					</div>

					<div class="summary-change-item">
						<div class="summary-change-item-value" v-fit>{{ data.rated }}</div>
						<div class="summary-change-item-text">rated</div>
					</div>

					<div class="summary-change-item">
						<div class="summary-change-item-value" v-fit>{{ data.wishlist }}</div>
						<div class="summary-change-item-text">wishlisted</div>
					</div>

				</div>

			</div>

			<div class="summary-change" v-if="active && data.trend">

				<div class="summary-change-title"><span>Growth</span></div>

				<div class="summary-change-items summary-change-items-trend">

					<div class="summary-change-item" v-if="data.trend.one !== null">

						<div class="summary-change-item-value is-trend" :class="{'is-up': data.trend.one > 0, 'is-down': data.trend.one < 0}" v-fit><i class="fa" :class="{'fa-caret-up': data.trend.one > 0, 'fa-caret-down': data.trend.one < 0}"></i><div>{{ Math.abs(data.trend.one) }}</div></div>
						<div class="summary-change-item-text">vs 1 month ago</div>

					</div>

					<div class="summary-change-item" v-if="data.trend.six !== null">

						<div class="summary-change-item-value is-trend" :class="{'is-up': data.trend.six > 0, 'is-down': data.trend.six < 0}" v-fit><i class="fa" :class="{'fa-caret-up': data.trend.six > 0, 'fa-caret-down': data.trend.six < 0}"></i><div>{{ Math.abs(data.trend.six) }}</div></div>
						<div class="summary-change-item-text">vs 6 months ago</div>

					</div>

					<div class="summary-change-item" v-if="data.trend.twelve !== null">

						<div class="summary-change-item-value is-trend" :class="{'is-up': data.trend.twelve > 0, 'is-down': data.trend.twelve < 0}" v-fit><i class="fa" :class="{'fa-caret-up': data.trend.twelve > 0, 'fa-caret-down': data.trend.twelve < 0}"></i><div>{{ Math.abs(data.trend.twelve) }}</div></div>
						<div class="summary-change-item-text">vs 12 months ago</div>

					</div>

				</div>

			</div>

		</core-widget>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comEmpty from './../common/Empty'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-empty': comEmpty
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/games/overview']

		},

		active: function() {

			return this.data && this.data.totalTouched !== undefined && !this.loading

		}

	}

}

</script>

<style scoped>

.summary {
	padding: 0px!important;
	border: 0px!important;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.is-mobile .summary {
	height: 100%;
}

.summary-total {
	display: flex;
	margin: 15px 0px 20px 0px;
	align-items: baseline;
	justify-content: center;
	color: #fff;
	font-size: 100px;
	font-weight: 700;
	width: 100%;
	text-align: center;
}

.summary-change {
	flex-shrink: 0;
	width: 100%;
	padding: 0px 10px 15px 10px;
}

.summary-change-items {
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
}

.summary-change-item {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.summary-change-items-trend .summary-change-item {
	width: 33.3%;
}

.summary-change-item-value {
	align-items: center;
	display: flex;
	color: #fff;
	height: 64px;
	font-weight: 500;
	font-size: 28px;
	justify-content: center;
}

.summary-change-item-value > div {
	height: 64px;
	display: flex;
	align-items: center;
}

.summary-change-item-value.is-trend.is-up {
	color: #5acf69;
}

.summary-change-item-value.is-trend.is-down {
	color: #9c150e;
}

.summary-change-item-value.is-trend .fa {
	font-size: 14px;
	margin-right: 6px;
}

.summary-change-item-text {
	height: 16px;
	flex-shrink: 0;
	color: #fff;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
}

.summary-change-title {
	font-size: 14px;
	line-height: 16px;
	font-weight: 500;
	color: #fff;
	text-align: center;
}

.summary-change-title span {
	background-color: #4881bb;
	display: inline-block;
	padding: 0px 20px;
	position: relative;
	z-index: 2;
}

.summary-change-title:after {
	content: ' ';
	display: block;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.2);
	position: absolute;
	right: 0px;
	top: 7px;
	left: 0px;
	z-index: 1;
}

</style>
